// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"592":"course","594":"about","597":"projects","966":"login"}[chunkId] + "." + {"592":"8def4811","594":"bfce813b","597":"884a214b","966":"fe471989"}[chunkId] + ".css";
};